import axiosInstance from "./service-instance";
import axios from "axios";
import { CONTENT_TYPES } from "constants";

export default {
    getDocumentChecklist: (case_id, type, paginate = false) =>
        axiosInstance.get("/document/checklist/", {
            params: {
                case_id,
                type,
                paginate
            }
        }),

    uploadDocument: data =>
        axiosInstance.post("/company/documents/create/", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }),
    getCompanyDocuments: company_id =>
        axiosInstance.get(`/company/${company_id}/documents/?paginate=false`),
    getCaseV2Documents: (company_id, case_id) =>
        axiosInstance.get(`/company/case/${case_id}/distinct-document/?paginate=false`),

    getCaseDocuments: (case_id , kycDocAssociate = false) =>
        axiosInstance.get(`/company/documents/${case_id}/?paginate=false&kyc_doc_associate=${kycDocAssociate}`),
    uploadDocuments: docs =>
        axiosInstance.post("/company/documents/create/", docs, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }),
    attachDocument: doc =>
        axiosInstance.post(`/company/documents/${doc.case}/`, doc, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    updateDocument: doc =>
        axiosInstance.put(`/company/documents/${doc.id}/detail/`, doc, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    uploadBulkDocuments: (companyId, docs, document_id, associate_id) =>
        axiosInstance.post(`/company/${companyId}/bulk-file-add/`, docs, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                document_id : document_id.toString().includes('-') ? document_id.toString().split('-')[0] : document_id,
                document_option : document_id.toString().includes('-') ? document_id.toString().split('-')[1] : null,
                associate_id : associate_id ? associate_id : null,
            }
        }),
    downloadDocuments: case_id =>
        axiosInstance.get(`company/document/${case_id}/zip-download/`, {
            responseType: "arraybuffer"
        }),

    actionDuplicateDocuments: (document_ids, action) =>{
        return( 
        axiosInstance.post(`company/remove-documents/`, { 
            document_ids,
            action
        }))},
    
    //
    //
    // document checklist creator apis
    //
    getDocumentsList: (page) =>
        axiosInstance.get("/document/document/list/", {
            params: {
                page
            }
        }),

    getDocumentCategoryList: (type) =>
        axiosInstance.get("/document/category/list/", {
            params: {
                type
            }
        }),

    getEntityList: () =>
        axiosInstance.get("/master/entity/list/"),

    getDocumentCheckListNew: () =>
        axiosInstance.get("/document/checklist-v2/create-list/"),

    retrieveSingleCheckList: (checklist_id) =>
        axiosInstance.get(`/document/checklist-v2/${checklist_id}`),

    updateDocumentChecklist: (checklist_id, data) =>
        axiosInstance.put(`/document/checklist-v2/${checklist_id}`, data),

    createDocumentChecklist: (data) =>
        axiosInstance.put("/document/checklist-v2/create-list", data),
    validateDocument: (company_id, document_id, data) =>
        axiosInstance.put(`/company/${company_id}/document-master/${document_id}/detail/`, data),
    inValidateDocument: (company_id, document_id, data) =>
        axiosInstance.put(`/company/${company_id}/document-master/${document_id}/detail/`, data),
    fetchDocumentMasterList: (companyId) =>
        axiosInstance.get(`/document/master/list/`, {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false,
                company_id : companyId
            }
        }),
    getAssociatesList: companyId =>
        axiosInstance.get(`/company/${companyId}/associates/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

        requestDocuments: (companyId, documents , caseId) =>
            axiosInstance.post(`/company/${companyId}/document-master/create/request-status/`, {
                documents
            }, {
                headers: {
                    "Content-Type": "application/json"
            },
            params:{
                "case_id": caseId
            }
        }),
        

    requestPostSanctionDocuments: (companyId, documents , caseId) =>
        axiosInstance.post(`/company/${companyId}/document-master/create/request-status/`,documents, {
            headers: {
                "Content-Type": "application/json"
            },
            params : {
                case_id : caseId
            }
        }),

    parseDocWithSignzy: (docType, url) =>
        axios.post(`https://doc-parse.progcap.com/${docType}`, {
            url
        }, {
            headers: {
                "Content-Type": "application/json"
            },
            timeout: 10000
        }),

    sendDocumentNotification: caseId =>
        axiosInstance.get(`/company/document/${caseId}/status-email/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    getDocumentUrl: (file_name, isInvoice) => {
        if(isInvoice) {
            return axios.get(`${file_name}`, {
                responseType: "arrayBuffer"
            });
        }
        return axios.get(file_name, {
            responseType: "arraybuffer"
        });
    },
    uploadBulkDocumentsV2: (caseId , data) =>
        axiosInstance.post(`/case/${caseId}/document/upload/`, data, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        }),

    attachCompanyDocument: doc =>
        axiosInstance.post(`/company/documents-db/${doc.company}/`, doc, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
};
